export default function computeAge(birthDate) {
  const start = new Date(birthDate);
  const end = new Date();

  let age = end.getFullYear() - start.getFullYear() - 1;
  if (
    end.getMonth() > start.getMonth() ||
    (end.getMonth() === start.getMonth() && end.getDate() >= start.getDate())
  ) {
    age += 1;
  }

  return age;
}
